import { useLocation } from 'react-router-dom';

function useAppLocation() {
    const { pathname } = useLocation();
    return {
        pathname,
        isManagePage: pathname === '/manage',
    };
}

export default useAppLocation;
